import { call, put, takeEvery } from 'redux-saga/effects';
import { initialize, requestFailure, requestSuccess } from './actionCreators';
import { requestPuppy } from '@wix/da-http-client';
function getFakeData() {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        const fakeData = require('./fake');
        return fakeData;
    }
    return false;
}
function* handleInitialize(action) {
    const result = yield call(requestPuppy, {
        method: 'get',
        url: '/user/friends/birthdays',
        params: {
            limit: 50
        }
    }, getFakeData);
    if (result) {
        yield put(requestSuccess(result));
    } else {
        yield put(requestFailure());
    }
}
export default function* BirthdayPopupRootSaga() {
    yield takeEvery(initialize, handleInitialize);
}

//# sourceMappingURL=saga.js.map